'use strict';

var angular = require('angular');
var modules = ['AVRO.Common.Rsql', 'AVRO.Common.Benchmark', 'AVRO.Common.DataRetriever', 'AVRO.Common.SearchCriteria', 'AVRO.PricingSummary.SummaryDashboardLegendFilterModule'];
module.exports = angular.module('AVRO.PricingSummary.Commons', modules).factory('PricingSummaryCommonsDataService', require('./services/PricingSummaryCommonsDataService'));